import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box, Typography, Link } from '@material-ui/core';
import NavBar from './NavBar';
import TopBar from './TopBar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    textAlign: 'center'
  }
}));

const DashboardLayout = ({ children }) => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            {children}
            <Box className={classes.footer}>
              <Typography variant="caption" color="textSecondary" display="block">
                Copyright © Original Author <Link href="https://antondevilliers.com/" target="_blank" rel="noopener noreferrer" color="inherit" style={{ textDecoration: 'underline' }}>Anton de Villiers</Link> (2021)
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block">
                All rights reserved. Original software protected under the South African <Link href="https://www.gov.za/sites/default/files/gcis_document/201504/act-98-1978.pdf" target="_blank" rel="noopener noreferrer" color="inherit" style={{ textDecoration: 'underline' }}>Copyright Act, 1978</Link> (Act 98 of 1978), including sections 22 and 23.
              </Typography>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node
};

export default DashboardLayout;
